import { atom } from "recoil";

export const ProductLandingePageState = atom({
  key: "ProductLandingPage",
  default: {
    seen: false,
  },
});
